import { render, staticRenderFns } from "./MerTradeOrderInfo.vue?vue&type=template&id=85f62534&scoped=true&"
import script from "./MerTradeOrderInfo.vue?vue&type=script&lang=js&"
export * from "./MerTradeOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./MerTradeOrderInfo.vue?vue&type=style&index=0&id=85f62534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f62534",
  null
  
)

export default component.exports